var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticStyle: {
      "position": "relative"
    }
  }, [_c('FilterFields', {
    attrs: {
      "fields": [{
        type: 'text',
        label: 'Número',
        field: 'numero'
      }, {
        type: 'text',
        label: 'Produto',
        field: 'produto'
      }, {
        type: 'text',
        label: 'Responsável',
        field: 'responsavel'
      }, {
        type: 'date',
        label: 'Dt. Término',
        field: 'data_termino'
      }, {
        type: 'date',
        label: 'Dt. Inicio',
        field: 'data_inicio'
      }, {
        type: 'date',
        label: 'Dt. Previsão',
        field: 'data_previsao'
      }, {
        type: 'date',
        label: 'Dt. Previsão término',
        field: 'data_previsao_termino'
      }, {
        type: 'select',
        label: 'Status',
        field: 'status',
        options: ['Não Iniciado', 'Em produção', 'Atrasado', 'Pausado', 'Entrega Parcial', 'Finalizado']
      }]
    }
  }), _c('TableApp', {
    ref: "producaoList",
    attrs: {
      "titulo": "Ordem de Produção",
      "acaoBtn": "/#/producao-nova",
      "textoBtn": "Nova Produção",
      "api-url": "/producao/lista",
      "fields": _vm.fields,
      "classFilterColumn": "numero",
      "perPage": 10
    },
    scopedSlots: _vm._u([{
      key: "customRow",
      fn: function fn(props) {
        return [props.field == 'numero' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "numero"
          },
          slot: "numero"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.numero) + " ")])])]) : _vm._e(), props.field == 'produto' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "produto"
          },
          slot: "produto"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [props.rowData.produto ? _c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.produto.descricao) + " ")]) : _vm._e()])]) : _vm._e(), props.field == 'responsavel' ? _c('span', {
          staticClass: "pl-0 pt-8",
          attrs: {
            "slot": "responsavel"
          },
          slot: "responsavel"
        }, [_c('div', {
          staticClass: "d-flex align-items-center"
        }, [_c('div', {
          staticClass: "font-weight-bold"
        }, [_vm._v(" " + _vm._s(props.rowData.responsavel) + " ")])])]) : _vm._e(), props.field == 'data_termino' ? _c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold",
          attrs: {
            "slot": "data_termino"
          },
          slot: "data_termino"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_termino, "DD/MM/YYYY")) + " ")]) : _vm._e(), props.field == 'data_inicio' ? _c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold",
          attrs: {
            "slot": "data_inicio"
          },
          slot: "data_inicio"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_inicio, "DD/MM/YYYY")) + " ")]) : _vm._e(), props.field == 'data_previsao' ? _c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold",
          attrs: {
            "slot": "data_previsao"
          },
          slot: "data_previsao"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_previsao, "DD/MM/YYYY")) + " ")]) : _vm._e(), props.field == 'data_previsao_termino' ? _c('div', {
          staticClass: "d-flex align-items-center justify-content-end font-weight-bold",
          attrs: {
            "slot": "data_previsao_termino"
          },
          slot: "data_previsao_termino"
        }, [_vm._v(" " + _vm._s(_vm._f("moment")(props.rowData.data_previsao_termino, "DD/MM/YYYY")) + " ")]) : _vm._e(), props.field == 'status' ? _c('span', {
          class: _vm.statusProducaoClass(props.rowData.status),
          attrs: {
            "slot": "status"
          },
          slot: "status"
        }, [_vm._v(" " + _vm._s(_vm.statusProducaoLabel(props.rowData.status)) + " ")]) : _vm._e(), props.field == 'valorTotal' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "valorTotal"
          },
          slot: "valorTotal"
        }, [_vm._v(" R$ " + _vm._s(_vm.numberToReal(props.rowData.valorTotal, 2)) + " ")]) : _vm._e(), props.field == 'actions' ? _c('span', {
          staticClass: "text-dark-75 font-weight-bolder d-block font-size-lg",
          attrs: {
            "slot": "actions"
          },
          slot: "actions"
        }, [_c('div', {
          staticClass: "action-buttons"
        }, [_c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Imprimir Ordem de Produção',
            expression: "'Imprimir Ordem de Produção'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.imprimirOP(props.rowData);
            }
          }
        }, [_c('PdfIcon', {
          attrs: {
            "size": 22
          }
        })], 1), props.rowData.status !== 6 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.bottom",
            value: 'Editar Ordem de Produção',
            expression: "'Editar Ordem de Produção'",
            modifiers: {
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-info btn-hover-info btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.editarProd(props.rowData);
            }
          }
        }, [_c('PencilIcon', {
          attrs: {
            "size": 20
          }
        })], 1) : _vm._e(), props.rowData.status != 6 && props.rowData.status != 5 ? _c('button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.bottom",
            value: 'Excluir',
            expression: "'Excluir'",
            modifiers: {
              "hover": true,
              "bottom": true
            }
          }],
          staticClass: "btn btn-sm btn-danger btn-hover-danger btn-icon mr-2",
          on: {
            "click": function click($event) {
              return _vm.excluir(props.rowData);
            }
          }
        }, [_c('TrashCanIcon', {
          attrs: {
            "size": 16
          }
        })], 1) : _vm._e()])]) : _vm._e()];
      }
    }])
  }), _c('SendToWppModal', {
    attrs: {
      "data": _vm.dataToWhatsapp,
      "openModal": _vm.wppOpenModal,
      "module": "os"
    },
    on: {
      "handleOpenModal": function handleOpenModal(openModal) {
        return _vm.wppOpenModal = openModal;
      }
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };